import { Stack, Chip } from '@mui/material';
import React from 'react';
import styles from './RadioTag.module.css';
export interface Tag {
  label: string;
  value: string;
}
interface SearchTagProps {
  options: Tag[];
  selected: Tag;
  handleChange: (tag: Tag) => void;
}

const RadioTag: React.FC<SearchTagProps> = ({ options, selected, handleChange }) => {
  return (
    <Stack direction={'row'} spacing={1} useFlexGap flexWrap='wrap'>
      {options.map(({ label, value }) => {
        const checked = value === selected.value;
        return (
          <Chip
            className={`${styles.container} ${checked ? styles.selected : styles.notSelected}`}
            key={`tag-${label}`}
            variant={checked ? 'filled' : 'outlined'}
            label={label}
            onClick={() => {
              handleChange({ label, value });
            }}
          />
        );
      })}
    </Stack>
  );
};
export default RadioTag;
